import "./IncrementButton.css";
import { useEffect, useState } from "react";

function IncrementButton({ onClick, disabled }) {
  const [classname, setClassname] = useState("increment");

  const onButtonClickHandler = () => {
    setClassname("increment anim");
    onClick();
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setClassname("increment");
    }, 100);
    return () => clearTimeout(timeoutId);
  }, [classname]);

  return (
    <button onClick={onButtonClickHandler} disabled={disabled} className={classname}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5Z"
          fill="var(--primary-1)"
          stroke="var(--primary-1)"
        />
        <path
          d="M18.75 15H15M15 15H11.25M15 15V11.25M15 15V18.75"
          stroke="white"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}

export default IncrementButton;
